import { useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import DocumentListItem from "./DocumentListItem"
import { detailsActions } from "../../../../../store/details"
import { caseTypeOptions, documentsTypes } from "../../../../../lib/systemData"
import Card from "../../../../common/Card"
import PannelHeader from "../../../../fragments/PannelHeader"
import Button from "../../../../common/Button"
import PannelBody from "../../../../fragments/PannelBody"

import { isDeletedCaseDocument } from "../../../../../lib/docs"

import classes from './DocumentsSidebar.module.css'

const DocumentsSidebar = () => {
    const dispatch = useDispatch()   

    const [activeDocsClip, setActiveDocsClip] = useState(6)
    
    const activeCase = useSelector(state => state.case.activeCase) 

    const openTabHandler = () => {
        dispatch(detailsActions.setActiveTab(11))
    }   

    const fullDocumentsList = useMemo(() => documentsTypes() || [], [])
    const caseTypes = useMemo(() => caseTypeOptions() || [], [])
    const activeDocs = useMemo(() => {
        const caseTypeId = activeCase?.case?.case_type_id
        if (!caseTypeId) {
            return null
        }
        const caseType = caseTypes.find((item) => item.value === caseTypeId)
        if (!caseType?.document_types) {
            return null
        }

        const caseDocumentTypeSet = new Set(
            (activeCase?.documents ?? [])
                .filter((item) => !isDeletedCaseDocument(item))
                .map((item) => item.document_type_id)
        )
        const docsById = new Map(fullDocumentsList.map((item) => [item.value, item]))
        const mappedDocs = caseType.document_types
            .map((docId) => docsById.get(docId))
            .filter(Boolean)
            .map((item) => ({
                ...item,
                is_completed: caseDocumentTypeSet.has(item.value)
            }))
            .sort((x, y) => ((x.is_completed === y.is_completed) ? 0 : x.is_completed ? 1 : -1))

        return mappedDocs
    }, [activeCase?.case?.case_type_id, activeCase?.documents, caseTypes, fullDocumentsList])
    const allCompletedDocs = useMemo(() => (
        (activeDocs ?? []).filter((item) => item.is_completed).length
    ), [activeDocs])

    function showClippedDocumentshandler() {
        if (activeDocs && activeDocs.length > activeDocsClip) {
            setActiveDocsClip(activeDocs.length)
        } else {
            setActiveDocsClip(6)
        }
        
    }

    return <Card>
        <PannelHeader>
            <div className="flex-vertical-center">
                <div className={classes.counter_wrapper}>
                    <h2>Documents to be scanned</h2>
                    {activeDocs && <span className={classes.counter}>{activeDocs.length - allCompletedDocs}</span>}
                </div>
                <Button btnStyle='btn_simple' click={openTabHandler} bypassisCaseArchived={true}>View All <i className="ti ti-arrow-up-right"></i></Button>
            </div>
        </PannelHeader>
        <PannelBody>
            {activeDocs && <div>
                <div className={classes.documents_container}>
                    {activeDocs.filter((item, index) => index < activeDocsClip).map(item => (
                        <DocumentListItem key={item.value} data={item} />
                    ))}                    
                </div>    
                {(activeDocs.length > 6) && <button onClick={showClippedDocumentshandler} className={classes.expand_button}>
                    {(activeDocs.length > activeDocsClip) &&  <><span>+ {activeDocs.length - 6} other documents</span> <i className="ti ti-chevron-down"></i></>}  
                    {!(activeDocs.length > activeDocsClip) &&  <><span>- hide extra documents</span> <i className="ti ti-chevron-up"></i></>}   
                </button>}
            </div>}

            {!activeDocs && <div className={classes.documents_container}><p>Please select a Case Type first.</p></div>}      
        </PannelBody>
    </Card>
}

export default DocumentsSidebar